module.exports = __webpack_public_path__ + "static/media/fondo1.0875bc74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fondo1.png
// module id = 777
// module chunks = 0